export function request(data) {
    return {
        type: 'SPORTS_GET_REQUEST',
        data
    };
}

export function error(errors) {
    return {
        type: 'SPORTS_GET_ERROR',
        errors
    };
}

export function finish(sports) {
    return {
        type: 'SPORTS_GET_FINISH',
        sports
    };
}
